import { ComponentType, SVGProps } from 'react';
import {
  BuildingIcon,
  DevicesIcon,
  RefreshIcon,
  RingsIcon,
  SuitcaseIcon,
  TruckIcon,
} from '../../../assets/icons';
import { SUPPORT_PHONE_NUMBER } from '../../../core/constants';

export const faqContent: FaqContent[] = [
  {
    card: {
      title: 'Pedido Site/App',
      description: 'Acompanhe pedidos, aprove solicitações e autorize terceiros.',
      icon: DevicesIcon,
    },
    sections: [
      '<b>Prazo de aprovação:</b> Pedidos pagos com cartão de crédito são aprovados em até 72 horas úteis. Você receberá um e-mail de confirmação assim que o pedido for aprovado.',
      `<b>Compra não aprovada:</b> Você receberá um e-mail de cancelamento. Entre em contato com o SAC pelo telefone <b>${SUPPORT_PHONE_NUMBER}</b> ou por e-mail para entender o motivo e resolver.`,
      '<b>Adicionar produtos ao pedido:</b> Não é possível incluir novos itens após a finalização. Para comprar algo a mais, realize um novo pedido separado.',
      `<b>Status “entregue” sem receber o produto:</b> Entre em contato imediatamente pelo telefone <b>${SUPPORT_PHONE_NUMBER}</b> ou por e-mail informando o seu CPF/CNPJ para que possamos verificar o ocorrido.`,
      '<b>Autorizar terceiros para retirar:</b> Entre em contato com o SAC e envie foto de documento com foto e CPF/CNPJ — tanto do titular quanto de quem vai retirar — além do Termo de Autorização disponível para download.',
    ],
  },
  {
    card: {
      title: 'Entrega',
      description: 'Consulte modalidades, prazos e orientações sobre atrasos.',
      icon: TruckIcon,
    },
    sections: [
      '<b>Modalidades disponíveis:</b> Entrega Convencional (recebe em casa), Clique e Retire (compra no site, retira na loja) e Entrega Expressa (receba em até 3 horas).',
      '<b>Prazo de entrega:</b> Varia conforme o CEP e as dimensões do produto. No site, consulte o prazo no carrinho inserindo seu CEP. Em lojas físicas, o prazo é de até 10 dias úteis.',
      '<b>Quem pode receber:</b> Porteiros, familiares, secretárias ou qualquer responsável maior de 18 anos, mediante assinatura do comprovante e apresentação de documento.',
      '<b>Entrega parcial:</b> É normal receber produtos separadamente. A data depende da disponibilidade de estoque e do faturamento de cada item. Acompanhe pelo seu perfil no site.',
      `<b>Pedido atrasado ou sem quem receber:</b> São feitas 2 tentativas de entrega. Em caso de atraso, entre em contato pelo telefone ${SUPPORT_PHONE_NUMBER} ou por e-mail com o CPF/CNPJ em mãos.`,
      '<b>Entrega em apartamento:</b> Sim, entregamos em andares superiores para produtos de até 300 kg. Subimos até três lances de escada quando não há elevador.',
    ],
  },
  {
    card: {
      title: 'Trocas e Devoluções',
      description: 'Consulte prazos, regras e solicitações de troca ou devolução.',
      icon: RefreshIcon,
    },
    sections: [
      `Os prazos e condições variam conforme o canal de compra. Para mais informações, entre em contato pelo telefone ${SUPPORT_PHONE_NUMBER} ou consulte a Política de Trocas e Devoluções.`,
      `
                <b>Compras pelo site ou app:</b>
                <ul>
                    <li>Arrependimento (sem defeito): solicite a devolução em até 7 dias corridos após o recebimento.</li>
                    <li>Produto com defeito: solicite atendimento em até 7 dias corridos. Após esse prazo, o suporte deve ser realizado pela assistência técnica do fabricante.</li>
                    <li>Produto importado: prazo de até <b>90 dias</b> para solicitar troca.</li>
                </ul>
            `,
      `
                <b>Compras em loja física:</b>
                <ul>
                    <li>Sem defeito: troque em até <b>15 dias corridos</b>, apresentando nota fiscal e produto em perfeito estado.</li>
                    <li>Com defeito: solicite troca em até <b>7 dias</b> corridos ou agende coleta pelo SAC. Após esse período, o atendimento será realizado pela assistência técnica do fabricante.</li>
                </ul>
            `,
      '<b>Condições gerais:</b> O produto deve estar sem sinais de uso, na embalagem original, com manual, acessórios e nota fiscal. Celulares e eletrônicos devem ser devolvidos sem dados pessoais e restaurados para o padrão de fábrica.',
      '<b>Não são passíveis de troca:</b> pisos, porcelanatos e tintas após aplicação; ar-condicionado split após instalação; celulares com mais de 60 minutos de uso; produtos com sinais de mau uso ou fora da validade.',
      '<b>Restituição de valores:</b> O reembolso pode ocorrer via crédito em loja, estorno no cartão de crédito ou depósito via Pix, débito ou boleto, conforme a forma de pagamento utilizada. Valores são restituídos apenas ao titular da compra (CPF/CNPJ).',
    ],
  },
  {
    card: {
      title: 'Lista de Casamento',
      description: 'Crie sua lista grátis, ganhe bônus e receba presentes de qualquer lugar.',
      icon: RingsIcon,
    },
    sections: [
      '<b>Como criar:</b> A lista é gratuita e pode ser criada pelo site ou em uma de nossas lojas, com apoio da equipe.',
      '<b>Bônus de 3%:</b> Ao finalizar a lista, os noivos recebem 3% do valor dos presentes em créditos para compras.',
      '<b>Cartão virtual:</b> Todos os presentes são convertidos em créditos para uso no site e nas lojas físicas.',
      '<b>Facilidade para os convidados:</b> Amigos e familiares podem presentear de qualquer lugar, de forma simples e segura.',
      '<b>Encontrar uma lista:</b> Pesquise pelo nome do casal ou de um dos noivos para localizar a lista e enviar presentes.',
    ],
  },
  {
    card: {
      title: 'Vendas para Empresas',
      description: 'Aproveite condições exclusivas e atendimento especializado para empresas.',
      icon: BuildingIcon,
    },
    sections: [
      'A Ferreira Costa oferece atendimento especializado para empresas, com condições exclusivas para compras corporativas.',
      '<b>Horário de atendimento PJ na loja:</b> Segunda a sexta, das 8h às 17h, e aos sábados, das 8h às 12h.',
      `<b>Central de Atendimento:</b> Atendimento de segunda a sexta, das 8h às 18h, e aos sábados, das 8h às 12h, pelo telefone <b>${SUPPORT_PHONE_NUMBER}.</b>`,
      '<b>Trocas e devoluções PJ:</b> Realizadas mediante apresentação da NF-e. Para contribuintes de ICMS, é necessária Nota Fiscal de Devolução. Os prazos seguem as mesmas regras aplicadas para pessoa física.',
      '<b>Ressarcimentos PJ:</b> Créditos e depósitos são realizados exclusivamente para o CNPJ vinculado ao pedido.',
    ],
  },
  {
    card: {
      title: 'Trabalhe Conosco',
      description: 'Conheça vagas, áreas de atuação e o processo seletivo.',
      icon: SuitcaseIcon,
    },
    sections: [
      '<b>Quem pode se candidatar:</b> Qualquer pessoa interessada em fazer parte da Ferreira Costa, incluindo vagas para Pessoas com Deficiência (PcD).',
      '<b>Áreas de atuação:</b> Vendas, Atendimento e Serviços, Operações, Backoffice, Áreas Corporativas e FCx Labs (tecnologia e inovação).',
      '<b>O que oferecemos:</b> Desenvolvimento profissional, crescimento por mérito, Universidade Corporativa e um ambiente colaborativo com mais de 5.000 colaboradores.',
      '<b>Processo seletivo:</b> Após a inscrição, o perfil será analisado pela equipe de Gente & Gestão. As atualizações são enviadas por e-mail durante as etapas do processo.',
      '<b>Onde estamos:</b> 9 filiais no Nordeste. A Ferreira Costa é o 3º maior Home Center do Brasil.',
    ],
  },
];

export interface FaqContent {
  card: FaqCard;
  sections: string[];
}

export interface FaqCard {
  title: string;
  description: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
}
